import React from 'react'
import advisorTypes from '../../data/advisorTypes.json'
import { stringToSEO } from '../../utils/stringOps'

function ShowCompanyOrAuthAdvisers ({ relatedContents, sectionHeader }) {
  const companies = Array.from(new Set(relatedContents.map(a => a.id)))
    .map(id => {
      return relatedContents.find(a => a.id === id)
    })

  function getLawFirms (relatedContents, comapnyOrAuthId) {
    const lawFirms = Array.from(new Set(relatedContents.filter(c => c.contentType_2 === 17 && c.id === comapnyOrAuthId).map(a => a.id_2)))
      .map(id => {
        return relatedContents.find(a => a.id_2 === id && a.id === comapnyOrAuthId)
      })

    return (
      <>
        {lawFirms.map(c =>
          (
            <div className='adviser-item item-content' key={c.id_2}>
              <a href={`/#/content/${c.id}/${stringToSEO(c.title)}?referrer=portfolio_related_entityindividual`} rel='noopener noreferrer' target='_self'><b>{c.title}</b></a>
              <div className='firm-item'>
                {(c.title_2.toLowerCase() === 'undisclosed' || c.title_2.toLowerCase() === 'internal') ?
                  <>{c.title_2}</>
                  :
                  <a href={`/#/content/${c.id_2}/${stringToSEO(c.title_2)}?referrer=portfolio_related_entityindividual`} rel='noopener noreferrer' target='_self'>{c.title_2}</a>
                }                
                {advisorTypes.filter(x => x.id === c.type)[0]
                  ? <span> ({advisorTypes.filter(x => x.id === c.type)[0].name})</span>
                  : <span />}
              </div>
              <div>
                {getAdvisorsForLawFirm(relatedContents, comapnyOrAuthId, c.id_2)}
              </div>
            </div>
          ))}
      </>
    )
  }

  function getAdvisorsForLawFirm (relatedContents, comapnyOrAuthId, lawFirmID) {
    const advisors = Array.from(new Set(relatedContents.filter(c => c.id_2 === lawFirmID && c.id === comapnyOrAuthId && c.contentType_3 === 21)))

    return (
      <>
        {advisors.map(c =>
          (
            <div className='person-item' key={c.id_3}>
              {(c.title_3.toLowerCase() === 'undisclosed' || c.title_3.toLowerCase() === 'internal') ?
                <>{c.title_3}</>
                :
                <a href={`/#/content/${c.id_3}/${stringToSEO(c.title_3)}?referrer=portfolio_related_entityindividual`} rel='noopener noreferrer' target='_self'>{c.title_3}</a>
              }              
              {(c.role !== '') ? <span> ({c.role})</span> : null}
            </div>
          ))}
      </>
    )
  }

  return (
    <>
      {(companies.length > 0) ? (
        <div className='article-advisers box-container'>
          <div className='box-header'>{sectionHeader}</div>
          <div className='box-inner'>
            {companies.map(content =>
              (
                <div className='advisers-wrapper' key={content.id}>
                  {getLawFirms(relatedContents, content.id)}
                </div>
              ))}
          </div>
        </div>
      ) : null}

    </>
  )
}

export default ShowCompanyOrAuthAdvisers
